import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { CargoFormComponent } from '../cargo-form/cargo-form.component';
import { ActivatedRoute } from '@angular/router';
import { RoleEnum } from '@core/models/role';
import { MessageService } from '@core/services/message.service';
import { ColumnOrder } from '@core/table/order';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { BehaviorSubject } from 'rxjs';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { addFormControls } from '@shared/util/util';
import { EntidadeCargoService } from '@core/services/entidade.cargo.service';

@Component({
  selector: 'app-cargo-list',
  templateUrl: './cargo-list.component.html',
  styleUrls: ['./cargo-list.component.scss']
})
export class CargoListComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() entidadeForm!: FormGroup;
  @Input() entidade: any;

  @Input() somenteVisualizar!: any;

  @ViewChild(CargoFormComponent) cargoFormComponent!: CargoFormComponent;
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  cargo: any;
  dataSet: any[] = [];

  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;

  statusContato: any[] = [];
  empresas: any[] = [];
  statusContatos: any[] = [];

  validaDetrans: any;
  size: NzButtonSize = 'large';
  situacoes: any[] = [];
  tiposContato: any[] = [];
  contatosSuperior: any;
  searchChange$ = new BehaviorSubject('');
  optionList: string[] = [];
  gruposEconomico: any[] = [];
  nzpage = 0;
  total = 0;
  nzFilterOption = (): boolean => true;

  loading = false;

  contato: any;

  constructor(
    public route: ActivatedRoute,
    private appSignalDataService: AppSignalDataService,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private messageService: MessageService,
    private entidadeCargoService: EntidadeCargoService
  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }

  ngOnChanges(): void {
    if (this.entidade && this.entidade.entidadeCargos) {
      const cargos = this.entidade.entidadeCargos;

      this.dataSet = cargos;
    }
  }

  ngAfterViewInit(): void {
    this.cargoFormComponent?.dadosCargoEmit.subscribe((res: any) => {
      const itemExiste = this.dataSet.filter(item => item.idCargoReferencia === res?.idCargoReferencia);
      const index = this.dataSet.findIndex(item => item.idCargoReferencia === itemExiste[0]?.idCargoReferencia);

      if (index != -1 ) {
        this.dataSet[index] = res;
        this.enviarCargo();
      } else {
        this.dataSet.push(res);
        this.enviarCargo();
      }
    });
  }

  ngOnInit(): void {
    console.log('somenteVisualizar', this.somenteVisualizar);


    this.construirForm();
  }

  construirForm() {
    addFormControls(this.entidadeForm, {
      entidadeCargos: [],

    });
  }

  onSearch(value: string): void {
    this.loading = true;
    this.searchChange$.next(value);
  }

  sort(event: any) {
    const column = event.sort.find((x: any) => x.value);
    if (column) {
      const sortKey = column.key;
      const sortOrder = column.value === 'ascend' ? 1 : -1;

      this.dataSet = [...this.dataSet].sort((a, b) => {
        const valueA = this.getNestedValue(a, sortKey);
        const valueB = this.getNestedValue(b, sortKey);

        if (valueA < valueB) {
          return -1 * sortOrder;
        }
        if (valueA > valueB) {
          return 1 * sortOrder;
        }
        return 0;
      });
    } else {
      this.dataSet = [...this.dataSet];
    }
  }

  getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((o, k) => (o ? o[k] : null), obj);
  }

  editarItem(obj: any) {
    this.cargo = obj;
  }

  removerCargo(cargoParaRemover: any): void {
    const index: number = this.dataSet.findIndex(item => item.idCargoReferencia === cargoParaRemover.idCargoReferencia);

    if (index !== -1) {
      this.dataSet.splice(index, 1);

      if(cargoParaRemover.id) {
        this.deleteEntidadesCargo(cargoParaRemover);
      }

      this.enviarCargo();
    } else {
      this.messageService.error('Cargo não encontrado para remoção.');
    }
  }

  deleteEntidadesCargo(cargo: any) {
    this.entidadeCargoService.deleteEntidadeCargo(cargo, this.entidade?.id).subscribe({
      next: () => {
        this.messageService.success('Cargo removido com sucesso!');
      },
      error: (err) => {
        this.messageService.error('Erro ao remover cargo: ' + err.message);
      }
    });
  }


  editarCargoSubordinado(obj: any) {

    console.log('obj', obj);
    this.cargo = obj;
    this.entidadeForm.patchValue({
      id: obj?.id,
      idCargoReferencia: obj.idCargoReferencia,
      nivelHierarquico: obj?.nivelHierarquico,
      nomeCargoReferencia: obj?.nomeCargoReferencia
    });
  }




  enviarCargo() {
    this.entidadeForm.get('entidadeCargos')?.setValue(this.dataSet);
  }
}
